<template>
  <div class="sc-object-card__image">
    <img class="sc-object-card__image-wrapper" :src="imageUrl" />
  </div>
</template>

<script>
import constants from "@/constants/url";

export default {
  props: {
    data: {
      refreshData: null,
      type: Object,
      default: () => null,
      required: true
    }
  },
  computed: {
    imageId() {
      return this.data.id.split("id:")[1];
    },
    token() {
      return this.$store.state.auth.token;
    },
    phase() {
      return this.data.phase === 14 ? 0 : this.data.phase;
    },
    imageUrl() {
      // eslint-disable-next-line
      return `${constants.BASE_URL}/rest/chsmeo_bmp?guid={978D21E4-5C89-41BE-93E6-E2724B05A6D2}&objid=${this.imageId}&phase=${this.phase}&w=250&background=1&format=from_service&access_token=${this.token}`;
    }
  }
};
</script>

<style lang="scss">
.sc-object-card__image {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border: 1px solid;
  border-radius: var(--border-radius);
  border-color: var(--dividers_low_contrast) !important;
  img {
    padding: 4px;
    border-radius: var(--border-radius);
    overflow: hidden;
    max-width: calc(100% - 8px);
    width: calc(100% - 8px);
  }
}
</style>
